import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {ProjectsService} from 'src/app/shared/API-Service/services/projects.service'
import {OnlineDonationStateService} from 'src/app/shared/API-Service/services/online-donation-state.service'

@Component({
  selector: 'app-Online-Donations-Stats',
  templateUrl: './Online-Donations-Stats.component.html',
  styleUrls: ['./Online-Donations-Stats.component.css']
})
export class OnlineDonationsStatsComponent implements OnInit {
  projects:any
  OnlineDonationState: any;
  SearchForm = {
    fromDate: null,
    toDate: null,
    project: null,
  }
  constructor(private _FormBuilder:FormBuilder,private ProjectsService:ProjectsService,private OnlineDonationStateService:OnlineDonationStateService) { }


  ngOnInit() {
    this.GetProjects()
    this.GetDonationHome()
    
  }
  GetProjects(){
    this.ProjectsService.GetProjects().subscribe(res=>{
      this.projects=res.data
    })
  }
 
  GetDonationHome(){
        this.OnlineDonationStateService.GetDonationHome(this.SearchForm).subscribe(res=>{
this.OnlineDonationState=res.data
console.log(this.OnlineDonationState)
    })
  }
  onSubmit(){
if(!this.SearchForm.fromDate){
  this.SearchForm.fromDate=null
}
 if(!this.SearchForm.toDate){
  this.SearchForm.toDate=null

 }
this.GetDonationHome()
  }
}
